<template>
  <div class='container mb-3'>
    <div class='row'>
      <div class='col-12 w80 m0a h400 scrollable bwhite fs14 pt-3 pb-3'>
        <p>・従来通り、お客様と現地にてお待ち合わせを頂き、物件をご案内頂く方法です。</p>
        <p>・鍵の取得に関しては、この後発行される鍵発行ナビに従って取得してください。</p>
        <p>・物件の場所と鍵の取得場所が異なる場合がございますので、事前にナビより場所のご確認をお願い致します。</p>
        <p>・鍵取得時には本人確認を実施致します。その為、必ず担当者として登録された方が現地でご案内を行ってださい。</p>
      </div>
    </div>
    <div class='row w80 m0a mt-4'>
      <div class='col-6 text-center pl-0'>
        <button class='btn btn-lg btn-block btn-rounded btn-secondary' @click="onStepSelected('top')">
          <i class="fas fa-backward"></i>
            別の方法にする
        </button>
      </div>
      <div class='col-6 text-center pr-0'>
        <button class='btn btn-lg btn-block btn-rounded btn-success' @click="showCautionModal()">
          現地案内にする
          <i class="fas fa-forward"></i>
        </button>
        <caution-modal @onStepSelected="onStepSelected"/>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import cautionModal from '@/components/company/LocalCautionModal.vue'
export default {
  name: 'LocalGuidanceIntroduction',
  components: { cautionModal },
  data() {
    return {
    }
  },
  async mounted() {
  },
  computed: {
  },
  methods: {
    onStepSelected(step){
      this.$emit('onStepSelected', step)
    },
    showCautionModal(){
      this.$modal.show('local-caution-modal')
    }
  },
  watch: {
  }
}
</script>

<style scoped>
.w80{
  width: 80% !important
}
.h400{
  height: 300px !important
}
.m0a{
  margin: 0 auto;
}
.scrollable {
  overflow: scroll;
}
.bwhite {
  background: white;
}
</style>
